/** Finance & Project view strings (merged into featureMessages). */

export const financeProjectMessagesTh: Record<string, string> = {
  // Finance
  'finance.slipImagesOnly': 'อนุญาตเฉพาะไฟล์รูปภาพ',
  'finance.slipTooLarge': 'ขนาดไฟล์ต้องไม่เกิน 10 MB',
  'finance.transactionUpdated': 'แก้ไขรายการแล้ว',
  'finance.transactionSaved': 'บันทึกข้อมูลการเงินแล้ว',
  'finance.transactionSaveError': 'เกิดข้อผิดพลาดในการบันทึกรายการ',
  'finance.confirmDeleteTransaction': 'ต้องการลบรายการธุรกรรมการเงินนี้ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
  'finance.transactionDeleted': 'ลบรายการสำเร็จ',
  'finance.transactionDeleteError': 'เกิดข้อผิดพลาดในการลบรายการ',
  'finance.categoryAdded': 'เพิ่มหมวดหมู่แล้ว',
  'finance.categoryAddError': 'เพิ่มหมวดหมู่ไม่สำเร็จ',
  'finance.colorUpdateError': 'อัปเดตสีไม่สำเร็จ',
  'finance.categoryNameSaved': 'บันทึกชื่อหมวดหมู่แล้ว',
  'finance.saveError': 'บันทึกไม่สำเร็จ',
  'finance.confirmDeleteCategory': 'ลบหมวดหมู่',
  'finance.confirmDeleteCategoryBody': 'ลบหมวดหมู่ "{name}"? รายการที่ใช้หมวดนี้จะถูกย้ายไปหมวดอื่นอัตโนมัติ',
  'finance.categoryDeleted': 'ลบหมวดหมู่แล้ว',
  'finance.categoryDeletedReassigned': 'ลบหมวดหมู่แล้ว — ย้าย {count} รายการไป "{to}"',
  'finance.categoryDeleteError': 'ลบหมวดหมู่ไม่สำเร็จ',
  'finance.recurringUpdated': 'แก้ไขรายจ่ายประจำแล้ว',
  'finance.recurringAdded': 'เพิ่มรายจ่ายประจำแล้ว',
  'finance.confirmDeleteRecurring': 'ลบรายจ่ายประจำ',
  'finance.itemDeleted': 'ลบรายการแล้ว',
  'finance.itemDeleteError': 'ลบไม่สำเร็จ',
  'finance.recurringRecorded': 'บันทึกรายจ่ายเดือนนี้แล้ว',
  'finance.statusUpdateError': 'อัปเดตสถานะไม่สำเร็จ',
  'finance.income': 'รายรับ',
  'finance.expense': 'รายจ่าย',
  'finance.budgetAlertTitle': 'รายจ่ายเดือนนี้ถึงเกณฑ์ที่ตั้งไว้',
  'finance.budgetAlertAmount': '{current} / {threshold}',
  'finance.title': 'ระบบบัญชีและการเงินเซิร์ฟเวอร์',
  'finance.subtitle': 'วิเคราะห์งบการเงิน รายรับ-รายจ่าย รายงานปันผลประจำเดือน',
  'finance.exportTitle': 'รายการการเงิน',
  'finance.exportColDate': 'วันที่',
  'finance.exportColType': 'ประเภท',
  'finance.exportColCategory': 'หมวด',
  'finance.exportColAmount': 'จำนวน',
  'finance.exportColDescription': 'รายละเอียด',
  'finance.categories': 'หมวดหมู่',
  'finance.addTransaction': 'เพิ่มธุรกรรมใหม่',
  'finance.payoutEstimate': 'ประมาณการปันผลเดือนนี้',
  'finance.payoutNetProfit': 'กำไรสุทธิเดือนนี้ {amount}',
  'finance.dateFilterLabel': 'ตัวกรองช่วงเวลา:',
  'finance.filterAllTime': 'ทั้งหมด',
  'finance.filter7Days': '7 วันล่าสุด',
  'finance.filter30Days': '30 วันล่าสุด',
  'finance.filterThisMonth': 'เดือนนี้',
  'finance.filterLastMonth': 'เดือนที่แล้ว',
  'finance.filterCustom': 'กำหนดเอง',
  'finance.dateStart': 'เริ่มต้น',
  'finance.dateTo': 'ถึง',
  'finance.dateEnd': 'สิ้นสุด',
  'finance.totalIncomeFiltered': 'รายรับทั้งหมด (Filtered)',
  'finance.totalExpenseFiltered': 'รายจ่ายทั้งหมด (Filtered)',
  'finance.netBalanceFiltered': 'คงเหลือสุทธิ (Filtered)',
  'finance.chartIncomeExpense': 'กราฟรายรับ-รายจ่าย',
  'finance.chartBreakdown': 'สัดส่วนตามหมวดหมู่',
  'finance.dataPoints': '{count} จุดข้อมูล',
  'finance.chartGraph': 'กราฟ',
  'finance.chartBreakdownShort': 'สัดส่วน',
  'finance.noDataInRange': 'ไม่มีข้อมูลในช่วงเวลาที่เลือก',
  'finance.incomeShare': 'สัดส่วนรายรับ',
  'finance.expenseShare': 'สัดส่วนรายจ่าย',
  'finance.total': 'ยอดรวม',
  'finance.noData': 'ไม่มีข้อมูล',
  'finance.noCategoryStats': 'ไม่มีสถิติในหมวดหมู่นี้',
  'finance.momAnalysis': 'วิเคราะห์เปรียบเทียบเดือนต่อเดือน (MoM Analysis)',
  'finance.thisMonthIncome': 'รายรับเดือนนี้',
  'finance.thisMonthExpense': 'รายจ่ายเดือนนี้',
  'finance.thisMonthProfit': 'กำไรสุทธิเดือนนี้',
  'finance.vsLastMonth': 'vs เดือนที่แล้ว',
  'finance.recurringExpenses': 'รายจ่ายประจำเดือน',
  'finance.recurringActiveTotal': 'รวมที่เปิดใช้งาน',
  'finance.perMonth': '/ เดือน',
  'finance.addRecurring': 'เพิ่มรายจ่ายประจำ',
  'finance.noRecurringEditable': 'ยังไม่มีรายจ่ายประจำ — กดเพิ่มเพื่อตั้งค่ารายการที่จ่ายทุกเดือน',
  'finance.noRecurringReadonly': 'ยังไม่มีรายจ่ายประจำ — รอผู้ดูแลเพิ่มรายการ',
  'finance.dayOfMonth': 'วันที่ {day} ของเดือน',
  'finance.recorded': 'บันทึกแล้ว',
  'finance.pendingRecord': 'รอบันทึก',
  'finance.disabled': 'ปิดใช้งาน',
  'finance.recordAsExpense': 'บันทึกเป็นรายจ่ายเดือนนี้',
  'finance.record': 'บันทึก',
  'finance.disable': 'ปิดใช้งาน',
  'finance.enable': 'เปิดใช้งาน',
  'finance.colDate': 'วันที่ทำรายการ',
  'finance.colType': 'ประเภท',
  'finance.colCategory': 'หมวดหมู่',
  'finance.colDescription': 'รายละเอียด / คำอธิบาย',
  'finance.colSlip': 'สลิป',
  'finance.colAmount': 'จำนวนเงิน',
  'finance.viewSlip': 'ดูสลิป',
  'finance.editItem': 'แก้ไขรายการ',
  'finance.deleteItem': 'ลบรายการ',
  'finance.noTransactions': 'ไม่พบรายการธุรกรรม',
  'finance.noTransactionsDesc': 'ไม่พบประวัติรายการบัญชีการเงินในช่วงเวลาที่ระบุในขณะนี้',
  'finance.pagination': 'แสดง {start}–{end} จาก {total} รายการ',
  'finance.prevPage': 'ก่อนหน้า',
  'finance.nextPage': 'ถัดไป',
  'finance.pageInputTitle': 'พิมพ์เลขหน้าที่ต้องการแล้วกด Enter',
  'finance.editTransaction': 'แก้ไขรายการบัญชี',
  'finance.newTransaction': 'บันทึกรายการบัญชีใหม่',
  'finance.accountType': 'ประเภทบัญชี',
  'finance.selectCategory': 'เลือกหมวดหมู่',
  'finance.noCategoriesHint': 'ยังไม่มีหมวดหมู่ —',
  'finance.addCategory': 'เพิ่มหมวดหมู่',
  'finance.amountThb': 'จำนวนเงิน (THB)',
  'finance.amountPlaceholder': 'ป้อนจำนวนเงิน...',
  'finance.transactionDate': 'วันที่ทำรายการ',
  'finance.extraDescription': 'คำอธิบายเพิ่มเติม',
  'finance.descriptionPlaceholder': 'ระบุข้อความสั้นๆ...',
  'finance.attachSlip': 'แนบสลิป / หลักฐานการจ่าย',
  'finance.slipPreviewAlt': 'ตัวอย่างสลิป',
  'finance.removeImage': 'ลบรูป',
  'finance.clickToAttachSlip': 'คลิกเพื่อแนบสลิป',
  'finance.slipFormats': 'PNG, JPG, WebP — สูงสุด 10 MB',
  'finance.saveEdit': 'บันทึกการแก้ไข',
  'finance.saveTransaction': 'บันทึกธุรกรรม',
  'finance.editRecurring': 'แก้ไขรายจ่ายประจำ',
  'finance.addRecurringMonthly': 'เพิ่มรายจ่ายประจำเดือน',
  'finance.itemName': 'ชื่อรายการ',
  'finance.itemNamePlaceholder': 'เช่น ค่าโฮสติ้ง, ค่า Discord Nitro',
  'finance.noExpenseCategories': 'ยังไม่มีหมวดหมู่รายจ่าย —',
  'finance.dayOfMonthLabel': 'วันที่ครบกำหนด (1–31)',
  'finance.optionalDescription': 'คำอธิบาย (ไม่บังคับ)',
  'finance.notesPlaceholder': 'หมายเหตุ...',
  'finance.enableItem': 'เปิดใช้งานรายการนี้',
  'finance.addItem': 'เพิ่มรายการ',
  'finance.expenseSlipAlt': 'สลิปรายจ่าย',
  'finance.manageCategories': 'จัดการหมวดหมู่',
  'finance.categoriesDesc': 'กำหนดหมวดหมู่รายรับ/รายจ่ายและสี — ใช้ร่วมกันทั้งทีม',
  'finance.editName': 'แก้ไขชื่อ',
  'finance.delete': 'ลบ',
  'finance.noCategories': 'ยังไม่มีหมวดหมู่',
  'finance.addNewCategory': 'เพิ่มหมวดหมู่ใหม่',
  'finance.categoryNamePlaceholder': 'ชื่อหมวดหมู่',
  'finance.add': 'เพิ่ม',

  // Project
  'project.column.planning': 'วางแผน (Planning)',
  'project.column.active': 'เตรียมการ (Active)',
  'project.column.inProgress': 'กำลังทำ (In Progress)',
  'project.column.testing': 'ทดสอบ (Testing)',
  'project.column.completed': 'เสร็จสิ้น (Completed)',
  'project.column.archived': 'เก็บถาวร (Archived)',
  'project.column.todo': 'To Do',
  'project.column.inProgressGroup': 'In Progress',
  'project.column.done': 'เสร็จสิ้น / เก็บถาวร (Done)',
  'project.status.planning': 'วางแผน',
  'project.status.active': 'เตรียมการ',
  'project.status.inProgress': 'กำลังทำ',
  'project.status.testing': 'ทดสอบ',
  'project.status.completed': 'เสร็จสิ้น',
  'project.status.archived': 'เก็บถาวร',
  'project.priority.low': 'ต่ำ',
  'project.priority.medium': 'ปานกลาง',
  'project.priority.high': 'สูง',
  'project.priority.critical': 'ด่วนมาก',
  'project.filter.allPriorities': 'ทั้งหมด',
  'project.priority.lowForm': 'ต่ำ (Low)',
  'project.priority.mediumForm': 'ปานกลาง (Medium)',
  'project.priority.highForm': 'สูง (High)',
  'project.priority.criticalForm': 'ด่วนมาก (Critical)',
  'project.priority.criticalDetail': 'ด่วนที่สุด (Critical)',
  'project.template.weeklyPatch': 'Weekly patch review',
  'project.template.bugFix': 'Bug fix sprint',
  'project.template.contentUpdate': 'Content / script update',
  'project.filter.allPeople': 'ทุกคน',
  'project.noProjectOption': '— ไม่มีโปรเจกต์ —',
  'project.unassigned': 'ยังไม่มอบหมาย',
  'project.clearAll': 'ล้างทั้งหมด',
  'project.selectTemplate': '— เลือกเทมเพลต —',
  'project.toast.projectCreated': 'สร้างโปรเจกต์ใหม่แล้ว',
  'project.toast.projectCreateError': 'เกิดข้อผิดพลาดในการสร้างโปรเจกต์',
  'project.confirm.deleteProject': 'ลบโปรเจกต์ "{name}"? งานในโปรเจกต์จะไม่ถูกลบ แต่จะถูกย้ายออกเป็นงานไม่มีโปรเจกต์',
  'project.toast.projectDeleted': 'ลบโปรเจกต์แล้ว',
  'project.toast.projectDeleteError': 'เกิดข้อผิดพลาดในการลบโปรเจกต์',
  'project.toast.taskCreated': 'สร้างการ์ดงานเรียบร้อยแล้ว',
  'project.toast.taskCreateError': 'เกิดข้อผิดพลาดในการสร้างงาน',
  'project.toast.statusUpdated': 'อัปเดตสถานะงานแล้ว',
  'project.confirm.deleteTask': 'ต้องการลบการ์ดงานนี้ใช่หรือไม่? การดำเนินการนี้จะไม่สามารถกู้คืนข้อมูลได้',
  'project.toast.taskDeleted': 'ลบงานเรียบร้อยแล้ว',
  'project.toast.taskDeleteError': 'เกิดข้อผิดพลาดในการลบงาน',
  'project.toast.taskUpdated': 'อัปเดตข้อมูลงานสำเร็จ',
  'project.toast.taskSaveError': 'เกิดข้อผิดพลาดในการบันทึกข้อมูล',
  'project.toast.subtaskAdded': 'เพิ่มรายการเช็กลิสต์แล้ว',
  'project.toast.subtaskAddError': 'เกิดข้อผิดพลาดในการเพิ่มรายการ',
  'project.toast.subtaskUpdateError': 'เกิดข้อผิดพลาดในการอัปเดตเช็กลิสต์',
  'project.toast.subtaskRenamed': 'แก้ไขรายการเช็กลิสต์แล้ว',
  'project.toast.subtaskDeleted': 'ลบรายการเช็กลิสต์แล้ว',
  'project.toast.subtaskDeleteError': 'เกิดข้อผิดพลาดในการลบรายการ',
  'project.toast.statusMoved': 'ย้ายสถานะงานสำเร็จ',
  'project.toast.statusMoveError': 'เกิดข้อผิดพลาดในการย้ายสถานะ',
  'project.title': 'การจัดการโครงการและบอร์ดงาน',
  'project.subtitle': 'บริหารจัดการโปรเจกต์ วางแผนและติดตามสถานะงานทีม',
  'project.view.board': 'บอร์ด',
  'project.view.table': 'ตาราง',
  'project.createTask': 'สร้างงานใหม่',
  'project.all': 'ทั้งหมด',
  'project.deleteProject': 'ลบโปรเจกต์',
  'project.noProject': 'ไม่มีโปรเจกต์',
  'project.newProject': 'โปรเจกต์ใหม่',
  'project.searchPlaceholder': 'ค้นหาชื่องาน รายละเอียด...',
  'project.filterPriority': 'กรองความสำคัญ',
  'project.filterAssignee': 'กรองผู้รับผิดชอบ',
  'project.filterDueWeek': 'Due 7 วัน',
  'project.filterCriticalOnly': 'Critical เท่านั้น',
  'project.filterMyTasks': 'งานของฉัน',
  'project.filterDueThisWeek': 'ครบกำหนดสัปดาห์นี้',
  'project.exportTitle': 'ส่งออกงาน',
  'project.exportFilename': 'project-tasks',
  'project.exportCol.title': 'ชื่องาน',
  'project.exportCol.status': 'สถานะ',
  'project.exportCol.priority': 'ความสำคัญ',
  'project.exportCol.due': 'กำหนดส่ง',
  'project.emptyColumn': 'ไม่มีงานในคอลัมน์นี้',
  'project.emptyArchived': 'ยังไม่มีงานที่เสร็จหรือเก็บถาวร',
  'project.table.titleCol': 'ชื่องานและรายละเอียด',
  'project.table.statusCol': 'สถานะ',
  'project.table.priorityCol': 'ความสำคัญ',
  'project.table.difficultyCol': 'ความยาก',
  'project.table.completionCol': 'ความสำเร็จ',
  'project.table.dueCol': 'กำหนดส่ง',
  'project.table.detailsCol': 'รายละเอียด',
  'project.openDetails': 'เปิดรายละเอียด',
  'project.emptyTable': 'ยังไม่มีข้อมูลโปรเจกต์งานในระบบ',
  'project.createCardTitle': 'สร้างการ์ดโครงการงานใหม่',
  'project.useTemplate': 'ใช้เทมเพลต',
  'project.taskTitle': 'หัวข้องาน',
  'project.taskTitlePlaceholder': 'เช่น พัฒนาระบบตู้คอนเทนเนอร์',
  'project.taskDescription': 'รายละเอียดงาน',
  'project.taskDescriptionPlaceholder': 'เขียนอธิบายรายละเอียดข้อความที่ต้องการงาน...',
  'project.priorityLabel': 'ระดับความสำคัญ',
  'project.difficultyLabel': 'ความยากง่าย',
  'project.difficulty.easy': 'ง่าย',
  'project.difficulty.medium': 'ปานกลาง',
  'project.difficulty.hard': 'ยาก',
  'project.difficulty.easyShort': 'E',
  'project.difficulty.mediumShort': 'M',
  'project.difficulty.hardShort': 'H',
  'project.projectLabel': 'โปรเจกต์',
  'project.initialStatus': 'สถานะเริ่มต้น',
  'project.assignees': 'ผู้รับผิดชอบ (เลือกได้หลายคน)',
  'project.selectTeam': '-- เลือกทีมงาน --',
  'project.dueDate': 'วันกำหนดส่ง',
  'project.startDate': 'เริ่ม',
  'project.endDate': 'สิ้นสุด',
  'project.createProjectTask': 'สร้างโครงการงาน',
  'project.taskIdHint': 'งาน ID: {id}',
  'project.descriptionLabel': 'คำอธิบายรายละเอียดงาน',
  'project.descriptionPlaceholder': 'คลิกเพื่อเขียนคำอธิบายรายละเอียดงานเพิ่มเติม...',
  'project.subtasksTitle': 'รายการเช็กลิสต์ย่อย',
  'project.noSubtasks': 'ยังไม่มีเช็กลิสต์ย่อยสำหรับงานนี้',
  'project.editSubtask': 'แก้ไขรายการ',
  'project.addSubtaskPlaceholder': 'เพิ่มรายการเช็คใหม่...',
  'project.add': 'เพิ่ม',
  'project.lastUpdated': 'อัปเดตล่าสุด',
  'project.metadataTitle': 'ข้อมูลสิทธิ์งาน',
  'project.projectStatus': 'สถานะโครงการ',
  'project.finishTask': 'Finish',
  'project.deleteTaskPermanent': 'ลบงานนี้ถาวร',
  'project.createProjectTitle': 'สร้างโปรเจกต์ใหม่',
  'project.projectName': 'ชื่อโปรเจกต์',
  'project.projectNamePlaceholder': 'เช่น ระบบเศรษฐกิจใหม่ Season 4',
  'project.projectColor': 'สีประจำโปรเจกต์',
  'project.createProject': 'สร้างโปรเจกต์',
  'project.card.projectTitle': 'โปรเจกต์: {name}',
  'project.card.expand': 'ขยาย',
  'project.card.collapse': 'ย่อ',
  'project.card.progress': 'ความคืบหน้า ({count} เช็ค)',
  'project.card.yours': 'ของคุณ',
  'project.card.peopleCount': '{count} คน',
};

export const financeProjectMessagesEn: Record<string, string> = {
  // Finance — concise labels (no redundant "Finance" prefix)
  'finance.slipImagesOnly': 'Images only',
  'finance.slipTooLarge': 'File must be 10 MB or less',
  'finance.transactionUpdated': 'Transaction updated',
  'finance.transactionSaved': 'Transaction saved',
  'finance.transactionSaveError': 'Failed to save transaction',
  'finance.confirmDeleteTransaction': 'Delete this transaction? This cannot be undone.',
  'finance.transactionDeleted': 'Transaction deleted',
  'finance.transactionDeleteError': 'Failed to delete transaction',
  'finance.categoryAdded': 'Category added',
  'finance.categoryAddError': 'Failed to add category',
  'finance.colorUpdateError': 'Failed to update color',
  'finance.categoryNameSaved': 'Category name saved',
  'finance.saveError': 'Save failed',
  'finance.confirmDeleteCategory': 'Delete category',
  'finance.confirmDeleteCategoryBody': 'Delete category "{name}"? Transactions using it will be moved to another category automatically',
  'finance.categoryDeleted': 'Category deleted',
  'finance.categoryDeletedReassigned': 'Category deleted — moved {count} item(s) to "{to}"',
  'finance.categoryDeleteError': 'Failed to delete category',
  'finance.recurringUpdated': 'Recurring expense updated',
  'finance.recurringAdded': 'Recurring expense added',
  'finance.confirmDeleteRecurring': 'Delete recurring expense',
  'finance.itemDeleted': 'Item deleted',
  'finance.itemDeleteError': 'Failed to delete',
  'finance.recurringRecorded': 'Recorded for this month',
  'finance.statusUpdateError': 'Failed to update status',
  'finance.income': 'Income',
  'finance.expense': 'Expense',
  'finance.budgetAlertTitle': 'Monthly spending reached threshold',
  'finance.budgetAlertAmount': '{current} / {threshold}',
  'finance.title': 'Accounts & finances',
  'finance.subtitle': 'Budget analysis, income/expense, and monthly payout estimates',
  'finance.exportTitle': 'Transactions',
  'finance.exportColDate': 'Date',
  'finance.exportColType': 'Type',
  'finance.exportColCategory': 'Category',
  'finance.exportColAmount': 'Amount',
  'finance.exportColDescription': 'Description',
  'finance.categories': 'Categories',
  'finance.addTransaction': 'Add transaction',
  'finance.payoutEstimate': 'This month payout estimate',
  'finance.payoutNetProfit': 'Net profit this month {amount}',
  'finance.dateFilterLabel': 'Date range:',
  'finance.filterAllTime': 'All time',
  'finance.filter7Days': 'Last 7 days',
  'finance.filter30Days': 'Last 30 days',
  'finance.filterThisMonth': 'This month',
  'finance.filterLastMonth': 'Last month',
  'finance.filterCustom': 'Custom',
  'finance.dateStart': 'Start',
  'finance.dateTo': 'to',
  'finance.dateEnd': 'End',
  'finance.totalIncomeFiltered': 'Total income',
  'finance.totalExpenseFiltered': 'Total expense',
  'finance.netBalanceFiltered': 'Net balance',
  'finance.chartIncomeExpense': 'Income vs expense',
  'finance.chartBreakdown': 'By category',
  'finance.dataPoints': '{count} data points',
  'finance.chartGraph': 'Chart',
  'finance.chartBreakdownShort': 'Breakdown',
  'finance.noDataInRange': 'No data in selected range',
  'finance.incomeShare': 'Income share',
  'finance.expenseShare': 'Expense share',
  'finance.total': 'Total',
  'finance.noData': 'No data',
  'finance.noCategoryStats': 'No stats for this category',
  'finance.momAnalysis': 'Month-over-month',
  'finance.thisMonthIncome': 'Income this month',
  'finance.thisMonthExpense': 'Expense this month',
  'finance.thisMonthProfit': 'Net profit this month',
  'finance.vsLastMonth': 'vs last month',
  'finance.recurringExpenses': 'Monthly recurring',
  'finance.recurringActiveTotal': 'Active total',
  'finance.perMonth': '/ month',
  'finance.addRecurring': 'Add recurring',
  'finance.noRecurringEditable': 'No recurring expenses — add one to track monthly bills',
  'finance.noRecurringReadonly': 'No recurring expenses yet',
  'finance.dayOfMonth': 'Day {day} of month',
  'finance.recorded': 'Recorded',
  'finance.pendingRecord': 'Pending',
  'finance.disabled': 'Disabled',
  'finance.recordAsExpense': 'Record as expense this month',
  'finance.record': 'Record',
  'finance.disable': 'Disable',
  'finance.enable': 'Enable',
  'finance.colDate': 'Date',
  'finance.colType': 'Type',
  'finance.colCategory': 'Category',
  'finance.colDescription': 'Description',
  'finance.colSlip': 'Slip',
  'finance.colAmount': 'Amount',
  'finance.viewSlip': 'View slip',
  'finance.editItem': 'Edit',
  'finance.deleteItem': 'Delete',
  'finance.noTransactions': 'No transactions',
  'finance.noTransactionsDesc': 'No transactions in the selected date range',
  'finance.pagination': 'Showing {start}–{end} of {total}',
  'finance.prevPage': 'Previous',
  'finance.nextPage': 'Next',
  'finance.pageInputTitle': 'Type page number and press Enter',
  'finance.editTransaction': 'Edit transaction',
  'finance.newTransaction': 'New transaction',
  'finance.accountType': 'Type',
  'finance.selectCategory': 'Select category',
  'finance.noCategoriesHint': 'No categories yet —',
  'finance.addCategory': 'Add category',
  'finance.amountThb': 'Amount (THB)',
  'finance.amountPlaceholder': 'Enter amount...',
  'finance.transactionDate': 'Date',
  'finance.extraDescription': 'Notes',
  'finance.descriptionPlaceholder': 'Short description...',
  'finance.attachSlip': 'Attach receipt / slip',
  'finance.slipPreviewAlt': 'Slip preview',
  'finance.removeImage': 'Remove',
  'finance.clickToAttachSlip': 'Click to attach slip',
  'finance.slipFormats': 'PNG, JPG, WebP — max 10 MB',
  'finance.saveEdit': 'Save changes',
  'finance.saveTransaction': 'Save',
  'finance.editRecurring': 'Edit recurring',
  'finance.addRecurringMonthly': 'Add monthly recurring',
  'finance.itemName': 'Item name',
  'finance.itemNamePlaceholder': 'e.g. Hosting, Discord Nitro',
  'finance.noExpenseCategories': 'No expense categories —',
  'finance.dayOfMonthLabel': 'Day of month (1–31)',
  'finance.optionalDescription': 'Notes (optional)',
  'finance.notesPlaceholder': 'Notes...',
  'finance.enableItem': 'Enable this item',
  'finance.addItem': 'Add',
  'finance.expenseSlipAlt': 'Expense slip',
  'finance.manageCategories': 'Manage categories',
  'finance.categoriesDesc': 'Set income/expense categories and colors — shared team-wide',
  'finance.editName': 'Edit name',
  'finance.delete': 'Delete',
  'finance.noCategories': 'No categories yet',
  'finance.addNewCategory': 'Add category',
  'finance.categoryNamePlaceholder': 'Category name',
  'finance.add': 'Add',

  // Project — concise labels (no redundant "Project" prefix)
  'project.column.planning': 'Planning',
  'project.column.active': 'Active',
  'project.column.inProgress': 'In progress',
  'project.column.testing': 'Testing',
  'project.column.completed': 'Completed',
  'project.column.archived': 'Archived',
  'project.column.todo': 'To Do',
  'project.column.inProgressGroup': 'In Progress',
  'project.column.done': 'Done',
  'project.status.planning': 'Planning',
  'project.status.active': 'Active',
  'project.status.inProgress': 'In progress',
  'project.status.testing': 'Testing',
  'project.status.completed': 'Completed',
  'project.status.archived': 'Archived',
  'project.priority.low': 'Low',
  'project.priority.medium': 'Medium',
  'project.priority.high': 'High',
  'project.priority.critical': 'Critical',
  'project.filter.allPriorities': 'All',
  'project.priority.lowForm': 'Low',
  'project.priority.mediumForm': 'Medium',
  'project.priority.highForm': 'High',
  'project.priority.criticalForm': 'Critical',
  'project.priority.criticalDetail': 'Critical',
  'project.template.weeklyPatch': 'Weekly patch review',
  'project.template.bugFix': 'Bug fix sprint',
  'project.template.contentUpdate': 'Content update',
  'project.filter.allPeople': 'Everyone',
  'project.noProjectOption': 'No project',
  'project.unassigned': 'Unassigned',
  'project.clearAll': 'Clear all',
  'project.selectTemplate': 'Select template',
  'project.toast.projectCreated': 'Project created',
  'project.toast.projectCreateError': 'Failed to create project',
  'project.confirm.deleteProject': 'Delete project "{name}"? Tasks will be kept but unlinked from this project.',
  'project.toast.projectDeleted': 'Project deleted',
  'project.toast.projectDeleteError': 'Failed to delete project',
  'project.toast.taskCreated': 'Task created',
  'project.toast.taskCreateError': 'Failed to create task',
  'project.toast.statusUpdated': 'Status updated',
  'project.confirm.deleteTask': 'Delete this task? This cannot be undone.',
  'project.toast.taskDeleted': 'Task deleted',
  'project.toast.taskDeleteError': 'Failed to delete task',
  'project.toast.taskUpdated': 'Task updated',
  'project.toast.taskSaveError': 'Failed to save task',
  'project.toast.subtaskAdded': 'Checklist item added',
  'project.toast.subtaskAddError': 'Failed to add item',
  'project.toast.subtaskUpdateError': 'Failed to update checklist',
  'project.toast.subtaskRenamed': 'Checklist item updated',
  'project.toast.subtaskDeleted': 'Checklist item removed',
  'project.toast.subtaskDeleteError': 'Failed to remove item',
  'project.toast.statusMoved': 'Status updated',
  'project.toast.statusMoveError': 'Failed to move status',
  'project.title': 'Projects & board',
  'project.subtitle': 'Manage projects, plan work, and track team progress',
  'project.view.board': 'Board',
  'project.view.table': 'Table',
  'project.createTask': 'New task',
  'project.all': 'All',
  'project.deleteProject': 'Delete project',
  'project.noProject': 'No project',
  'project.newProject': 'New project',
  'project.searchPlaceholder': 'Search tasks...',
  'project.filterPriority': 'Priority',
  'project.filterAssignee': 'Assignee',
  'project.filterDueWeek': 'Due in 7 days',
  'project.filterCriticalOnly': 'Critical only',
  'project.filterMyTasks': 'My tasks',
  'project.filterDueThisWeek': 'Due this week',
  'project.exportTitle': 'Export tasks',
  'project.exportFilename': 'tasks',
  'project.exportCol.title': 'Title',
  'project.exportCol.status': 'Status',
  'project.exportCol.priority': 'Priority',
  'project.exportCol.due': 'Due',
  'project.emptyColumn': 'No tasks in this column',
  'project.emptyArchived': 'No completed or archived tasks',
  'project.table.titleCol': 'Task',
  'project.table.statusCol': 'Status',
  'project.table.priorityCol': 'Priority',
  'project.table.difficultyCol': 'Difficulty',
  'project.table.completionCol': 'Progress',
  'project.table.dueCol': 'Due',
  'project.table.detailsCol': 'Details',
  'project.openDetails': 'Open',
  'project.emptyTable': 'No tasks yet',
  'project.createCardTitle': 'New task',
  'project.useTemplate': 'Template',
  'project.taskTitle': 'Title',
  'project.taskTitlePlaceholder': 'e.g. Container system',
  'project.taskDescription': 'Description',
  'project.taskDescriptionPlaceholder': 'Describe the task...',
  'project.priorityLabel': 'Priority',
  'project.difficultyLabel': 'Difficulty',
  'project.difficulty.easy': 'Easy',
  'project.difficulty.medium': 'Medium',
  'project.difficulty.hard': 'Hard',
  'project.difficulty.easyShort': 'E',
  'project.difficulty.mediumShort': 'M',
  'project.difficulty.hardShort': 'H',
  'project.projectLabel': 'Project',
  'project.initialStatus': 'Initial status',
  'project.assignees': 'Assignees',
  'project.selectTeam': 'Select team',
  'project.dueDate': 'Due date',
  'project.startDate': 'Start',
  'project.endDate': 'End',
  'project.createProjectTask': 'Create task',
  'project.taskIdHint': 'Task ID: {id}',
  'project.descriptionLabel': 'Description',
  'project.descriptionPlaceholder': 'Add details...',
  'project.subtasksTitle': 'Checklist',
  'project.noSubtasks': 'No checklist items yet',
  'project.editSubtask': 'Edit item',
  'project.addSubtaskPlaceholder': 'Add checklist item...',
  'project.add': 'Add',
  'project.lastUpdated': 'Last updated',
  'project.metadataTitle': 'Details',
  'project.projectStatus': 'Status',
  'project.finishTask': 'Finish',
  'project.deleteTaskPermanent': 'Delete permanently',
  'project.createProjectTitle': 'New project',
  'project.projectName': 'Name',
  'project.projectNamePlaceholder': 'e.g. Economy Season 4',
  'project.projectColor': 'Color',
  'project.createProject': 'Create',
  'project.card.projectTitle': '{name}',
  'project.card.expand': 'Expand',
  'project.card.collapse': 'Collapse',
  'project.card.progress': 'Progress ({count} checks)',
  'project.card.yours': 'Yours',
  'project.card.peopleCount': '{count} people',
};
